import { DRIVER_DEFAULT_PAY_RATE_TYPE } from '../redux/api/driver/driver.model';
import {
  TRIP_DRIVER_PAY_TYPE,
  TRIP_DRIVER_PAY_UNIT,
  TripDriverOtherPay
} from '../redux/api/trips/trips.model';

class DriverPayUtils {
  /**
   * Calculates the total pay amount of other pay items (substracting deductions)
   * @param otherPayItems
   * @returns Total pay amount
   */
  static getOtherPayItemsTotalAmount = (otherPayItems: TripDriverOtherPay[]): number => {
    return otherPayItems.reduce((acc, item) => {
      if (item.pay_type !== TRIP_DRIVER_PAY_TYPE.DEDUCTION) {
        return acc + (item.quantity || 1) * (item.rate || 0);
      } else {
        return acc - (item.quantity || 1) * (item.rate || 0);
      }
    }, 0);
  };

  /**
   * Get the driver pay rate type (unit) string value from the enum value
   * @param string
   * @returns the Driver Pay Rate Type (unit) enum value
   */
  static getDriverPayRateType = (value: string): string => {
    switch (value) {
      case 'Percentage':
        return DRIVER_DEFAULT_PAY_RATE_TYPE.PERCENTAGE || TRIP_DRIVER_PAY_UNIT.PERCENTAGE;
      case 'Per hour':
        return DRIVER_DEFAULT_PAY_RATE_TYPE.PER_HOUR || TRIP_DRIVER_PAY_UNIT.PER_HOUR;
      case 'Per mile':
        return DRIVER_DEFAULT_PAY_RATE_TYPE.PER_MILE || TRIP_DRIVER_PAY_UNIT.PER_MILE;
      case 'Flat':
        return DRIVER_DEFAULT_PAY_RATE_TYPE.FLAT || TRIP_DRIVER_PAY_UNIT.FLAT;
      default:
        return value;
    }
  };
}

export default DriverPayUtils;
